/**
 * Chunk an array and return the chunks as an array, as well as a getter (1 indexed) for individual pages.
 */
export function paginate<T>(items: T[], itemsPerPage: number) {
	const pages: T[][] = [];
	for (let i = 0; i < items.length; i += itemsPerPage) {
		const chunk = items.slice(i, i + itemsPerPage);
		pages.push(chunk);
	}

	const numberOfPages = pages.length;

	const getPageByNumber = (pageNumber: number) => {
		const pageIndex = pageNumber - 1;
		if (pageIndex < 0 || pageIndex > numberOfPages) {
			return pages[0] || [];
		}
		return pages[pageIndex] || [];
	};

	return { pages, numberOfPages, getPageByNumber };
}
